import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { assign as _assign, get as _get } from 'lodash-es';
//import './styles/index.scss';
import './styles/dcmain.scss';
import './styles/dcproduct.scss';
import './styles/popupBundler.scss';
import './styles/dcsPopup.scss';
import './styles/responsive.scss';
import CompatibleProducts from './components/compatible-products/CompatibleProducts';
import CompatibleProductsXrs from './components/compatible-products/CompatibleProductsXrs';
import CompatibleProductsXrsV3 from './components/compatible-products/CompatibleProductsXrsV3';
import CompatibleProductsXrsV3Collection from './components/compatible-products/CompatibleProductsXrsV3Collection';
// eslint-disable-next-line no-unused-vars
import CompatioAnalytics from './api/CompatioAnalytics'; // Importing this without using it so its available for specific implementations
import CompatibleWith from './components/compatible-with/CompatibleWith';
import { IntlProvider } from 'react-intl';
import Translation from './i18n/Translation';
import CompatibleWithHelper from './components/utils/CompatibleWithHelper';
import BuildItAnchor from './components/build-anchor/BuildItAnchor';
import BuildDCAnchor from './components/dc-build-anchor/BuildDCAnchor';
import SmartBundler from './components/smart-bundler/SmartBundler';
import CollectionFilterSection from './components/collection-filters/CollectionFilterSectionLive';
// import CollectionFilterSectionColGrid from './components/collection-filters/CollectionFilterSection-col-grid';
const locale = Translation.getLocale();
const translationMessages = Translation.getTranslations(locale);

//this below line for help to stop extra xrs api call when bundle loading...step one
window.compatioConfig.bundlerData = [];

document.querySelectorAll('[data-xrs-compatible-with]').forEach(element => {
  const hashObject = CompatibleWithHelper.getUrlHashObject();

  ReactDOM.render(
    <IntlProvider locale={locale} messages={translationMessages}>
      <CompatibleWith {...hashObject} />
    </IntlProvider>,
    element
  );
});

document.querySelectorAll('[data-xrs-anchor]').forEach(element => {
  const props = window.compatioConfig.compatibleProducts;
  ReactDOM.render(
    <IntlProvider locale={locale} messages={translationMessages}>
      <BuildItAnchor {...props} />
    </IntlProvider>,
    element
  );
});
/*
document.querySelectorAll('[data-xrs-compatible-products]').forEach(element => {
  const props = window.compatioConfig.compatibleProducts;

  ReactDOM.render(
    <IntlProvider locale={locale} messages={translationMessages}>
      <CompatibleProducts {...props} />
    </IntlProvider>,
    element
  );
});*/

document.querySelectorAll('[data-xrs-compatible-products]').forEach(element => {
  const platForm = window.compatioConfig.platForm
    ? window.compatioConfig.platForm
    : 'magento';
  const props = window.compatioConfig.compatibleProducts;
  const XRSV3 = window.compatioConfig.XRSVersion
    ? window.compatioConfig.XRSVersion
    : 'nodata';
  if (platForm == 'shopify') {
    if (XRSV3 == 'V3') {
      ReactDOM.render(
        <IntlProvider locale={locale} messages={translationMessages}>
          <CompatibleProductsXrsV3 {...props} />
        </IntlProvider>,
        element
      );
    } else {
      ReactDOM.render(
        <IntlProvider locale={locale} messages={translationMessages}>
          <CompatibleProductsXrs {...props} />
        </IntlProvider>,
        element
      );
    }
  } else if (platForm == 'magento') {
    if (XRSV3 == 'V3') {
      ReactDOM.render(
        <IntlProvider locale={locale} messages={translationMessages}>
          <CompatibleProductsXrsV3 {...props} />
        </IntlProvider>,
        element
      );
    } else {
      ReactDOM.render(
        <IntlProvider locale={locale} messages={translationMessages}>
          <CompatibleProductsXrs {...props} />
        </IntlProvider>,
        element
      );
    }
  } else {
    ReactDOM.render(
      <IntlProvider locale={locale} messages={translationMessages}>
        <CompatibleProducts {...props} />
      </IntlProvider>,
      element
    );
  }
});

// document.querySelectorAll('[data-xrs-smart-bundler]').forEach(element => {
//   const props = window.compatioConfig.compatibleProducts;
//   ReactDOM.render(
//     <IntlProvider locale={locale} messages={translationMessages}>
//       <SmartBundler parentProduct={props} />
//     </IntlProvider>,
//     element
//   );
// });

//this below Function for help to stop extra xrs api call when bundle loading...step three
function renderSmartBundler() {
  document.querySelectorAll('[data-xrs-smart-bundler]').forEach(element => {
    const props = window.compatioConfig.compatibleProducts;
    ReactDOM.render(
      <IntlProvider locale={locale} messages={translationMessages}>
        <SmartBundler
          parentProduct={props}
          bundlerDataNew={window.compatioConfig.bundlerData || []}
        />
      </IntlProvider>,
      element
    );
  });
}
// Add a custom event listener to trigger the render
window.addEventListener('bundlerDataReady', renderSmartBundler);

/*
document.querySelectorAll('[data-dc-anchor]').forEach(element => {
  const props = window.compatioConfig.compatibleProducts;
  ReactDOM.render(
    <IntlProvider locale={locale} messages={translationMessages}>
      <BuildDCAnchor {...props} />
    </IntlProvider>,
    element
  );
});
*/

document.querySelectorAll('[data-dc-anchor]').forEach(element => {
  const props = { ...window.compatioConfig.compatibleProducts };
  // console.log(props.productSku,'props')
  const fetchModelData = async sku => {
    try {
      const requestOptions = () => {
        return {
          method: 'GET',
          redirect: 'follow',
        };
      };
      const response = await fetch(
        `https://sku-svc.compat.io/builderV2/model/?channel_key=${_get(
          window,
          'compatioConfig.shopify.merchantKey'
        )}&sku=${sku}`,
        requestOptions()
      );
      const result = await response.json();
      props.modelIdJson = result;
      if (result.builderModels.length != 0) {
        ReactDOM.render(
          <IntlProvider locale={locale} messages={translationMessages}>
            <BuildDCAnchor {...props} />
          </IntlProvider>,
          element
        );
      }
      return await response.json(); // Return the fetched data
    } catch (error) {
      // console.error('Error fetching price engine data:', error);
    }
  };
  if (props.productSku != undefined) {
    fetchModelData(props.productSku);
  } else {
    ReactDOM.render(
      <IntlProvider locale={locale} messages={translationMessages}>
        <BuildDCAnchor {...props} />
      </IntlProvider>,
      element
    );
  }
});

document
  .querySelectorAll('[data-compatio-collection-products]')
  .forEach(element => {
    const ColGrid = window.compatioConfig.shopify.collectionLayout;

    /* 
    if (ColGrid == 'column-grid') {
      ReactDOM.render(
        <IntlProvider locale={locale} messages={translationMessages}>
          <CollectionFilterSectionColGrid />
        </IntlProvider>,
        element
      );
    } else { 
      
    }
   */
    ReactDOM.render(
      <IntlProvider locale={locale} messages={translationMessages}>
        <CollectionFilterSection />
      </IntlProvider>,
      element
    );
  });

document
  .querySelectorAll('[data-xrs-compatible-products-collection]')
  .forEach(element => {
    const platForm = window.compatioConfig.platForm
      ? window.compatioConfig.platForm
      : 'magento';
    const props = window.compatioConfig.compatibleProducts;

    if (platForm == 'shopify') {
      ReactDOM.render(
        <IntlProvider locale={locale} messages={translationMessages}>
          <CompatibleProductsXrsV3Collection {...props} />
        </IntlProvider>,
        element
      );
    }
  });
